







































































import { Vue, Component, Prop } from 'vue-property-decorator';
import BpcInput from '@shared/components/forms/inputs/input/input';
import { POSProductCancelData, POSTicket } from '@pos/interfaces/pos-v2';
import { Order } from '@accounting/interfaces/order';
import { Invoice } from '@accounting/interfaces/invoice';

@Component({
  name: 'bpc-pos-cancel-product-modal',
  components: { BpcInput },
})
export default class PosCancelProductModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Object, default: null }) readonly productCancelData: POSProductCancelData;

  isCanceling: boolean = false;
  isCheckoutOrders: boolean = false;
  successCancellation: boolean = false;
  hasNotRefund: boolean = false;
  orders: number[] = [];
  selectedTicket: Invoice = null;
  openedTickets: POSTicket[] = null;

  closeModal() {
    this.$emit('close-modal');
    this.orders = [];
    this.successCancellation = false;
    this.hasNotRefund = false;
  }

  get hasOrders(): boolean {
    return this.orders?.length > 0;
  }

  get refundAutomatically() {
    return this.hasOrders && !!this.productCancelData.destinyTicketId;
  }

  get availableOpenTickets() {
    const newTicket = [{ text: `${this.$t('global.pos.new_ticket')}`, value: null }];
    const openTickets = this.openedTickets?.map(ticket => {
      return {
        text: `${ticket.code} - ${ticket.total}€`,
        value: ticket,
      };
    });
    return newTicket.concat(openTickets);
  }

  get selectedTicketId(): number {
    return this.selectedTicket?.id;
  }

  async cancelProduct() {
    this.isCanceling = true;

    try {
      if (this.productCancelData.originTicketId) {
        // If there is originTicketId we are cancelling from a ticket
        this.orders = await this.$posService.cancelProductFromTicket(
          this.productCancelData.posSessionId,
          this.productCancelData.originTicketId,
          this.productCancelData.productId,
        );
      } else {
        // If not we cancel from a product
        this.orders = await this.$posService.cancelProductFromProduct(
          this.productCancelData.posSessionId,
          this.productCancelData.productType,
          this.productCancelData.productId,
        );
      }
    } catch (error) {
      console.error(error);
      this.isCanceling = false;
      return;
    }

    this.successCancellation = true;

    try {
      if (this.refundAutomatically) {
        await this.checkoutToTicket(this.productCancelData.destinyTicketId);
      } else if (this.hasOrders) {
        this.openedTickets = await this.$posService.getOpenedTickets(
          this.productCancelData.posSessionId,
        );
        this.openedTickets = this.openedTickets.filter(ticket => ticket.status !== 'paid');
      } else {
        this.hasNotRefund = true;
      }
    } catch (error) {
      console.error(error);
      this.isCanceling = false;
      return;
    }

    this.isCanceling = false;
  }

  async checkoutToTicket(ticketId: number) {
    this.isCheckoutOrders = true;
    const ticket = await this.$posService.checkoutToTicket(
      this.productCancelData.posSessionId,
      this.orders,
      this.productCancelData.contactId,
      ticketId,
    );
    this.$emit('checkout-ticket', ticket);
    this.closeModal();
    this.isCheckoutOrders = false;
  }
}
